export const getFullAuthorName = (authorName: string, authorSubname: string | null) =>
    authorSubname ? `${authorName} (${authorSubname})` : authorName;
